export default __webpack_public_path__ + "static/world-921c4743ee88ffe577ccb04d80479c39.jpg";